export default [
  {
    value: "if",
    label: "if",
    description: "Set up a conditional expression",
    args: ["condition", "value_if_true", "value_if_false"],
  },
  {
    value: "if_empty",
    label: "if_empty",
    description: "Set up a conditional expression for when a value is empty",
    args: ["condition", "value_if_empty", "value_if_not"],
  },
  {
    value: "contains",
    label: "contains",
    description: "Determine if a string is found within a piece of text",
    args: ["where_to_search", "search_term"],
  },
  {
    value: "round",
    label: "round",
    description: "Round a number to a specified precision",
    args: ["number", "precision"],
  },
  {
    value: "add_days",
    label: "add_days",
    description:
      "Adds a number of days to a supplied date. A negative number will minus the days",
    args: ["date", "daysToAdd"],
  },
  {
    value: "add_months",
    label: "add_months",
    description:
      "Adds a number of months to a supplied date. A negative number will minus the months",
    args: ["date", "monthsToAdd"],
  },
  {
    value: "add_years",
    label: "add_years",
    description:
      "Adds a number of years to a supplied date. A negative number will minus the years",
    args: ["date", "yearsToAdd"],
  },
  {
    value: "days_between",
    label: "days_between",
    description: "Get the difference in days between 2 dates",
    args: ["date1", "date2"],
  },
  {
    value: "uppercase",
    label: "uppercase",
    description: "Make all letter uppercase",
    args: ["text"],
  },
  {
    value: "lowercase",
    label: "lowercase",
    description: "Make all letter lowercase",
    args: ["text"],
  },
  {
    value: "capitalise",
    label: "capitalise",
    description: "Make the first letter of each word uppercase",
    args: ["text"],
  },
  {
    value: "convert_to_currency",
    label: "convert_to_currency",
    description:
      "Convert a value from one currency to another using the exchange rates set in HubSpot, or optionally set your own rate",
    args: ["value", "from", "to", "rate"],
  },
  {
    value: "format_date",
    label: "format_date",
    description: "Format a date using date tokens",
    args: ["date", "format"],
  },
  {
    value: "convert_from_timestamp",
    label: "convert_from_timestamp",
    description: "Convert a timestamp to ISO format",
    args: ["timestamp"],
  },
];
